
<div class="panel panel-primary" data-testid="add-picketline-modal">
    <div class="panel-heading">
      Add Picketline to {{strike.Title}}
    </div>
    <div class="panel-body">
      <form class="form-horizontal" role="form" [formGroup]="addPicketlineForm">
        <div class="row">
          <div class="col-xs-6 col-sm-4">
            <label for="picketLineName" class="control-label">Picketline Name</label>
            <input
                data-testid="picketline-name-input"
                class="form-control"
                name="picketLineName"
                id="picketLineName"
                type="text"
                formControlName="picketlineName"
                validate-on="blur"
                required required-message="'Name is required'">
          </div>
        </div>
        <div *ngIf="picketlineName?.invalid && (picketlineName?.dirty || picketlineName?.touched)">
          <div *ngIf="picketlineName?.errors?.['required']" data-testid="picketline-name-error-message">
            Name is required.
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-12">
            <label for="descr" class="control-label">Descr</label>
            <input
                data-testid="picketline-descr-input"
                class="form-control"
                name="descr"
                id="descr"
                type="text"
                formControlName="description">
          </div>
        </div>
        <div class="row">
          <div class="col-xs-8 selectContainer">
            <label for="selectedHouse" class="control-label">Available Houses</label>
            <select
                data-testid="picketline-houses-input"
                formControlName="strikeHouseId"
                name="selectedHouse"
                id="selectedHouse"
                class="form-control black"
                required>
              <option *ngFor="let option of allHouses" [ngValue]="option.ID">{{option.HouseId +' - ' + option.HouseName}}</option>
            </select>
          </div>
        </div>
        <div *ngIf="strikeHouseId?.invalid && (strikeHouseId?.dirty || strikeHouseId?.touched)">
          <div *ngIf="strikeHouseId?.errors?.['required']">
            House is required.
          </div>
        </div>
      </form>
    </div>
    <div class="panel-footer clearfix">
      <div class="pull-right">
        <button type="button" class="btn btn-danger" (click)="closeModal()" data-testid="picketline-cancel-button">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="addPicketline()" [disabled]="!addPicketlineForm.valid || disableButton" data-testid="picketline-add-button">Add Picketline</button>
      </div>
    </div>
  </div>
